import React from "react";

export type AdminTheme =
  | "light" | "dark"
  | "ocean" | "ocean-dark"
  | "navy" | "navy-dark"
  | "cobalt" | "cobalt-dark"
  | "teal" | "teal-dark"
  | "turquoise" | "turquoise-dark"
  | "forest" | "forest-dark"
  | "emerald" | "emerald-dark"
  | "sage" | "sage-dark"
  | "seafoam" | "seafoam-dark"
  | "slate" | "slate-dark"
  | "grape" | "grape-dark"
  | "rose" | "rose-dark";

interface ThemeContextValue {
  theme: AdminTheme;
  setTheme: (theme: AdminTheme) => void;
}

const ThemeContext = React.createContext<ThemeContextValue>({
  theme: "light",
  setTheme: () => {}
});

export default ThemeContext;
